let isSetup = false;

export function setupServiceWorkerObjectUrlBridge() {
    if (isSetup || typeof navigator === 'undefined' || !navigator.serviceWorker) {
        return;
    }
    isSetup = true;

    const handler = async (event: MessageEvent) => {
        const { type } = event.data || {};

        if (type === 'CREATE_OBJECT_URL') {
            try {
                const { blob } = event.data as { blob: Blob };
                const url = URL.createObjectURL(blob);
                let returnUrl: string = url;

                // @ts-ignore
                const processing = (window as any).mediaImageRepositoryProcessing;
                if (processing?.convertToHeicToJpegIfNeeded) {
                    returnUrl = await processing.convertToHeicToJpegIfNeeded(url);
                }

                const port = event.ports?.[0];
                port?.postMessage({ url: returnUrl });
            } catch (err: any) {
                event.ports?.[0]?.postMessage({ error: String(err?.message || err) });
            }
            return;
        }

        if (type === 'REVOKE_OBJECT_URL') {
            const { blobUrl } = event.data as { blobUrl?: string };
            const port = event.ports?.[0];
            try {
                if (blobUrl) {
                    URL.revokeObjectURL(blobUrl);
                }
                port?.postMessage({ ok: true });
            } catch (err: any) {
                port?.postMessage({ ok: false, error: String(err?.message || err) });
            }
        }
    };

    navigator.serviceWorker.addEventListener('message', handler);
}